document.addEventListener("DOMContentLoaded", function () {
    function updateGridNo(section) {
      let mediaQuery = window.matchMedia("(max-width: 749px)");
  
      if (mediaQuery.matches) {
        section.classList.remove("grid--2-col-tablet-down");
        section.classList.add("grid--1-col-tablet-down");
      } else {
        section.classList.remove("grid--1-col-tablet-down");
        section.classList.add("grid--2-col-tablet-down");
      }
    }
  
    function updateSectionss() {
      let sections = document.querySelectorAll("[data-dynamic-section]");
      sections.forEach(updateGridNo);
    }
  
    updateSectionss();

    window.addEventListener("resize", updateSectionss);
  
    document.addEventListener("shopify:section:load", function (event) {
      let section = event.target.querySelector("[data-dynamic-section]");
      if (section) updateGridNo(section);
    });
  });